import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'

import Charts from '../Charts'
import styles from '../MontlyRevenue.module.scss'
import { getHotelDisplayName } from '../utils/hotelHelpers'

export const MonthlyRevenueCharts = ({
  isErred,
  errorText,
  cumulativeData,
  response,
  groupHotelData,
  groupName,
  isFetching,
  groupedHotels,
  isDemoMode,
  dataToShow
}) => {
  if (isErred) {
    return (
      <div className={styles.noData}>
        <p>{errorText}</p>
      </div>
    )
  }

  return (
    <>
      {cumulativeData && (
        <>
          <p className={styles.groupTitle}></p>
          <Charts
            data={cumulativeData}
            firstYear={response.firstYear}
            secondYear={response.secondYear}
            name={`Total data of ${groupHotelData?.length} hotels`}
            syncId={groupName}
            dataToShow={dataToShow}
            isDemoMode={isDemoMode}
          />
        </>
      )}
      {groupHotelData.length === 0 && !isFetching && (
        <div className={styles.noData}>
          <p>No matching hotels</p>
        </div>
      )}
      {groupHotelData.length === 0 && isFetching && (
        <div className={styles.noData}>
          <LoadingIndicator />
        </div>
      )}
      {groupHotelData.length > 0 && (
        <div className={styles.chartsHolder}>
          {groupHotelData.length > 0 &&
            Object.keys(groupedHotels)
              .filter(s => !s.stateCode)
              .sort((a, b) =>
                groupedHotels[a][0].stateCode?.localeCompare(
                  groupedHotels[b][0]?.stateCode
                )
              )
              .map(groupCategory => (
                <div key={groupCategory}>
                  <p className={styles.groupTitle}>
                    {isDemoMode
                      ? 'Region'
                      : `${groupCategory}, ${groupedHotels[groupCategory][0].stateCode}`}
                  </p>
                  <div className={styles.rowGroup}>
                    {groupedHotels[groupCategory].map((hotel, index) => (
                      <Charts
                        firstYear={response.firstYear}
                        secondYear={response.secondYear}
                        data={hotel}
                        name={getHotelDisplayName(isDemoMode, hotel, index)}
                        syncId={hotel.hotelName}
                        dataToShow={dataToShow}
                        isDemoMode={isDemoMode}
                      />
                    ))}
                  </div>
                </div>
              ))}
        </div>
      )}
    </>
  )
}
